import {
    TimeChangeActionTypes,
    TIME_CHANGE_REQUEST_SUCCESS,
    TIME_CHANGE_REQUEST_FAILURE,
    TIME_CHANGE_REQUEST_CLEAR,
    TimeChangeRequestState,
    TIME_CHANGE_FLIGHTS_REQUEST_CLEAR,
    TIME_CHANGE_FLIGHTS_REQUEST_FAILURE,
    TIME_CHANGE_FLIGHTS_REQUEST_SUCCESS,
    TIME_CHANGE_FLIGHTS_AFTER_REJECTION_SUCCESS,
    TIME_CHANGE_FLIGHTS_AFTER_REJECTION_FAILURE,
    TIME_CHANGE_FLIGHTS_AFTER_REJECTION_CLEAR
} from './types';

const flightsByFlightNumberInitState: TimeChangeRequestState = {
    data: {
        rpl: null,
        id: ''
    }
}

export function timeChangeRequest(state = flightsByFlightNumberInitState, action: TimeChangeActionTypes) {
    switch (action.type) {
        case TIME_CHANGE_REQUEST_SUCCESS:
            return action.payload;
        case TIME_CHANGE_REQUEST_FAILURE:
            return action.payload;
        case TIME_CHANGE_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function timeChangeFlights(state = [], action: TimeChangeActionTypes) {
    switch (action.type) {
        case TIME_CHANGE_FLIGHTS_REQUEST_SUCCESS:
            return action.payload;
        case TIME_CHANGE_FLIGHTS_REQUEST_FAILURE:
            return action.payload;
        case TIME_CHANGE_FLIGHTS_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function timeChangeFlightsAfterRejection(state = [], action: TimeChangeActionTypes) {
    switch (action.type) {
        case TIME_CHANGE_FLIGHTS_AFTER_REJECTION_SUCCESS:
            return action.payload;
        case TIME_CHANGE_FLIGHTS_AFTER_REJECTION_FAILURE:
            return action.payload;
        case TIME_CHANGE_FLIGHTS_AFTER_REJECTION_CLEAR:
            return action.payload;
        default:
            return state;
    }
}